import { useRouter, type AppNavConfig, type NavItem } from '@khaddi/ui';
import { useMemo } from 'react';

export type TabKey = 'home' | 'menu' | 'orders' | 'rewards' | 'account';

const TABS: { key: TabKey; label: string; icon: NavItem['icon']; path: string }[] = [
  { key: 'home', label: 'Trang chủ', icon: 'home', path: '/' },
  { key: 'menu', label: 'Thực đơn', icon: 'cup', path: '/menu' },
  { key: 'orders', label: 'Đơn hàng', icon: 'receipt', path: '/orders' },
  { key: 'rewards', label: 'Ưu đãi', icon: 'gift', path: '/rewards' },
  { key: 'account', label: 'Tài khoản', icon: 'user', path: '/account' },
];

/** Main nav for `Screen`; sub-screens pass `{ wideOnly: true }` so phones keep their back button instead. */
export const useTabNav = (active: TabKey, { wideOnly = false }: { wideOnly?: boolean } = {}): AppNavConfig => {
  const { navigate } = useRouter();
  return useMemo(
    () => ({
      items: TABS.map((tab) => ({ key: tab.key, label: tab.label, icon: tab.icon, onPress: () => navigate(tab.path) })),
      active,
      label: 'Điều hướng chính',
      wideOnly,
    }),
    [navigate, active, wideOnly],
  );
};
